export default "/images/SilverAward.png?e1cba5a8c4a82b51e80825227615e2e2";